
export function isZG() {
  // return window.origin === 'https://eshemingpin.rchz.top';
  return window.origin === 'https://shoujizulin.hzrjkf.com';

}


// WEBPACK FOOTER //
// ./src/config/platform.js